import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';

const SaisieNumeriqueEtatCivilPage = () => {
  const getImagePath = (fileName) => {
    if (!fileName || fileName.trim() === '') return null;
    const cleanName = fileName.trim();
    const extensions = ['.jpg', '.jpeg', '.png', '.webp', '.JPG', '.JPEG', '.PNG'];
    const hasExtension = extensions.some((ext) => cleanName.endsWith(ext));
    return hasExtension
      ? `/assets/etatcivil/${cleanName}`
      : `/assets/etatcivil/${cleanName}.jpg`;
  };

  const photos = [
    {
      src: 'gitega6.jpeg',
      title: 'Formation des agents d’état civil à l’application mobile de saisie',
      alt: 'Formation des agents',
    },
    {
      src: '20260610_163909.jpg',
      title: 'Distribution du matériel informatique (tablettes et batteries externes)',
      alt: 'Distribution des tablettes',
    },
    {
      src: '20260613_122329.jpg',
      title: 'Suivi opérationnel et accompagnement sur le terrain dans les communes',
      alt: 'Mission de suivi',
    },
  ];

  return (
    <div style={styles.container}>
      <NavigationBar />

      <main style={styles.main}>
        {/* En-tête actualité */}
        <header style={styles.header}>
          <div style={styles.projectBanner}>
            <span style={styles.projectTag}>INSBU</span>
            <span style={styles.financeTag}>État civil</span>
            <span style={styles.financeTag}>PNUD</span>
          </div>

          <h1 style={styles.title}>
            Saisie numérique des faits d’état civil 2025 :<br />
            <span style={{ fontSize: '1.4rem', color: '#333' }}>
              l’INSBU et le Ministère de l’Intérieur mobilisent les communes
            </span>
          </h1>

          <div style={styles.metaInfo}>
            <span style={styles.date}>09 – 13 juin 2026</span>
            <span style={styles.location}>Opération nationale</span>
          </div>
        </header>

        {/* Corps de l'actualité */}
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>
            <span style={styles.sectionNumber}>•</span>
            Une opération d’envergure pour moderniser l’état civil
          </h2>

          <p style={styles.paragraph}>
            <strong>En date du 09 au 13 juin 2026</strong>, l’<strong>Institut National de la Statistique du Burundi (INSBU)</strong>, en collaboration avec le <strong>Ministère de l’Intérieur, de la Sécurité Publique et du Développement Communautaire</strong>, a conduit une mission nationale de suivi et de renforcement des compétences des agents d’état civil. Cette action s’inscrit dans le cadre de la digitalisation des registres de naissances, mariages, décès et reconnaissances pour l’année 2025.
          </p>

          <p style={styles.paragraph}>
            Grâce à l’appui financier du <strong>Programme des Nations Unies pour le Développement (PNUD)</strong>, des tablettes équipées d’une application de collecte ont été déployées dans l’ensemble des communes. L’objectif : reporter l’intégralité des données physiques vers une base numérique, afin de fiabiliser les statistiques démographiques et d’en faciliter l’exploitation.
          </p>

          <p style={styles.paragraph}>
            Cette opération marque une étape clé vers la généralisation de la saisie numérique comme activité de routine pour les agents d’état civil, contribuant ainsi à la modernisation du système statistique national.
          </p>
        </section>

        {/* Objectifs clés – version concise */}
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>
            <span style={styles.sectionNumber}>•</span>
            Ce que la mission a permis
          </h2>

          <div style={styles.objectivesGrid}>
            <div style={styles.objectiveCard}>
              <span style={styles.objectiveNumber}>✓</span>
              <p style={styles.objectiveText}>
                Former les agents aux procédures harmonisées de saisie numérique des faits enregistrés en 2025
              </p>
            </div>
            <div style={styles.objectiveCard}>
              <span style={styles.objectiveNumber}>✓</span>
              <p style={styles.objectiveText}>
                Renforcer leurs compétences techniques sur l’application mobile de saisie
              </p>
            </div>
            <div style={styles.objectiveCard}>
              <span style={styles.objectiveNumber}>✓</span>
              <p style={styles.objectiveText}>
                Distribuer le matériel informatique (tablettes et power banks) nécessaire
              </p>
            </div>
            <div style={styles.objectiveCard}>
              <span style={styles.objectiveNumber}>✓</span>
              <p style={styles.objectiveText}>
                Assurer un suivi de proximité du démarrage effectif des opérations dans les communes
              </p>
            </div>
            <div style={styles.objectiveCard}>
              <span style={styles.objectiveNumber}>✓</span>
              <p style={styles.objectiveText}>
                Vérifier l’adéquation entre les effectifs et le volume des registres à traiter
              </p>
            </div>
            <div style={styles.objectiveCard}>
              <span style={styles.objectiveNumber}>✓</span>
              <p style={styles.objectiveText}>
                Identifier et résoudre les contraintes opérationnelles sur le terrain
              </p>
            </div>
          </div>
        </section>

        {/* Photos et déroulement */}
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>
            <span style={styles.sectionNumber}>•</span>
            Sur le terrain
          </h2>

          <p style={styles.paragraph}>
            Les équipes de l’INSBU et du Ministère de l’Intérieur, de la Sécurité Publique et du Développement Communautaire ont parcouru tous les provinces pour superviser les premières saisies, échanger avec les agents communaux et s’assurer que les conditions matérielles et techniques étaient réunies. Les échanges ont permis d’ajuster les procédures et de renforcer la confiance des acteurs locaux.
          </p>

          <div style={styles.imageRow}>
            {photos.map((photo, index) => (
              <div key={index} style={styles.imageWrapper}>
                <img
                  src={getImagePath(photo.src)}
                  alt={photo.alt}
                  style={styles.inlineImage}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = '/assets/placeholder-event.jpg';
                  }}
                />
                <p style={styles.imageCaption}>{photo.title}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Conclusion – actualité avec perspectives */}
        <section style={styles.thanksSection}>
          <h2 style={styles.thanksTitle}>Vers une base de données démographiques fiable</h2>
          <p style={styles.thanksText}>
            Cette mission pose les jalons d’un système d’état civil entièrement numérisé, qui fournira des données démographiques actualisées et fiables, essentielles à la planification du développement. L’INSBU et ses partenaires poursuivent leur engagement pour une transformation numérique durable du Système Statistique National.
          </p>
          <p style={styles.thanksText}>
            L’INSBU remercie le Ministère de l’Intérieur, le PNUD et l’ensemble des agents d’état civil pour leur mobilisation et leur professionnalisme.
          </p>
        </section>
      </main>

      <Footer />
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: '#f5f5f5',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  main: {
    flex: 1,
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '20px',
    width: '100%',
  },
  header: {
    textAlign: 'center',
    marginBottom: '50px',
    paddingBottom: '25px',
    borderBottom: `2px solid #008D36`,
  },
  projectBanner: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '20px',
    marginBottom: '20px',
  },
  projectTag: {
    backgroundColor: '#E30613',
    color: 'white',
    padding: '8px 20px',
    borderRadius: '20px',
    fontSize: '0.9rem',
    fontWeight: 'bold',
  },
  financeTag: {
    backgroundColor: '#008D36',
    color: '#f5f5f5',
    padding: '8px 20px',
    borderRadius: '20px',
    fontSize: '0.9rem',
    fontWeight: 'bold',
  },
  title: {
    color: '#008D36',
    fontSize: '1.8rem',
    marginBottom: '15px',
    fontWeight: '600',
    lineHeight: 1.3,
    padding: '0 20px',
  },
  metaInfo: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '30px',
    marginBottom: '30px',
  },
  date: {
    padding: '8px 20px',
    backgroundColor: '#f0f0f0',
    borderRadius: '20px',
    fontSize: '1rem',
    fontWeight: '500',
  },
  location: {
    padding: '8px 20px',
    backgroundColor: '#f0f0f0',
    borderRadius: '20px',
    fontSize: '1rem',
    fontWeight: '500',
  },
  section: {
    marginBottom: '60px',
    padding: '30px',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  },
  sectionTitle: {
    color: '#008D36',
    fontSize: '1.8rem',
    marginBottom: '25px',
    display: 'flex',
    alignItems: 'center',
    fontWeight: '600',
  },
  sectionNumber: {
    color: '#E30613',
    fontSize: '2.2rem',
    marginRight: '15px',
    fontWeight: 'bold',
  },
  paragraph: {
    marginBottom: '20px',
    textAlign: 'justify',
    fontSize: '1.1rem',
    lineHeight: 1.7,
    color: '#333',
  },
  objectivesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '16px',
    marginTop: '20px',
  },
  objectiveCard: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    padding: '16px',
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    borderLeft: '4px solid #008D36',
  },
  objectiveNumber: {
    color: '#008D36',
    fontSize: '1.4rem',
    fontWeight: 'bold',
    lineHeight: 1.2,
    flexShrink: 0,
  },
  objectiveText: {
    margin: 0,
    fontSize: '1rem',
    lineHeight: 1.5,
    color: '#333',
  },
  imageRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '30px',
    justifyContent: 'center',
    marginTop: '30px',
  },
  imageWrapper: {
    flex: '1 1 280px',
    maxWidth: '350px',
    textAlign: 'center',
  },
  inlineImage: {
    width: '100%',
    height: 'auto',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  imageCaption: {
    fontSize: '0.85rem',
    color: '#666',
    marginTop: '8px',
    fontStyle: 'italic',
    lineHeight: 1.4,
  },
  thanksSection: {
    padding: '30px',
    backgroundColor: '#e8f5e9',
    borderRadius: '8px',
    textAlign: 'center',
    border: '1px solid #008D36',
    marginBottom: '40px',
  },
  thanksTitle: {
    color: '#008D36',
    fontSize: '1.6rem',
    marginBottom: '15px',
    fontWeight: '600',
  },
  thanksText: {
    fontSize: '1.05rem',
    lineHeight: 1.7,
    color: '#333',
    marginBottom: '15px',
  },
};

export default SaisieNumeriqueEtatCivilPage;